export const SUPPORT_EMAIL = 'support@pitchbook.com';

type SupportMailtoParams = {
    accountName?: string | null,
    accountId?: number | null,
    stepNumber?: number | null,
    stepLabel?: string | null,
};

/**
 * Builds a `mailto:` link to PitchBook Support with a pre-filled subject line.
 *
 * The subject is a pipe-joined list of the available identifying parts, in order:
 * `<account name> | <account id> | Step <n>: <label> | SSO portal`. Any part that
 * is not provided is skipped, so screens without a wizard step (e.g. existing
 * connection, draft locked) simply omit the step segment. When only one of the
 * step number/label is present, that one is used alone. The `SSO portal` marker
 * is always present so support can route the request.
 */
function formatStep(stepNumber?: number | null, stepLabel?: string | null): string | null {
    const hasLabel = stepLabel != null && stepLabel.length > 0;
    if (stepNumber != null && hasLabel) {
        return `Step ${stepNumber}: ${stepLabel}`;
    }
    if (stepNumber != null) {
        return `Step ${stepNumber}`;
    }
    if (hasLabel) {
        return stepLabel;
    }
    return null;
}

export function buildSupportMailto({accountName, accountId, stepNumber, stepLabel}: SupportMailtoParams = {}): string {
    const parts: string[] = [];

    if (accountName != null && accountName.length > 0) {
        parts.push(accountName);
    }
    if (accountId != null) {
        parts.push(String(accountId));
    }
    const step = formatStep(stepNumber, stepLabel);
    if (step != null) {
        parts.push(step);
    }
    parts.push('SSO portal');

    const subject = parts.join(' | ');
    return `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`;
}
